
<script>
  import { BTabs } from 'bootstrap-vue';

  export default {
    name: 'Tabs',
    extends: BTabs,
  }
</script>
